import React, { useEffect } from "react";

const TermAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="m-auto my-20 max-md:my-4 w-[80%] justify-center items-center max-sm:py-8 max-sm:px-3 sm:p-8 border rounded-lg shadow-lg bg-white">
      <div className="sm:p-6">
        <h1 className="text-3xl font-bold mb-4 text-[#730000]">Terms and Conditions</h1>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <p className="mb-2">
            At Select Proposal, your privacy is important to us. We collect, use, and protect your data with care. Our Privacy Policy includes:
          </p>

          <hr className="mb-2 border-t border-gray-400" />

          <h2 className="text-2xl font-semibold mb-2 text-[#730000]">
            1. What We Collect
          </h2>
          <p className="mb-2">We may collect the following:</p>
          <ul className="list-disc list-inside">
            <li>Your name, email, and contact number</li>
            <li>Personal details like age, gender, religion, education, etc.</li>
            <li>Photos and biodata</li>
            <li>Information you provide during registration or while using our site</li>
          </ul>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-2 text-[#730000]">
            2. How We Use Your Data
          </h2>
          <p className="mb-2">We use your data to:</p>
          <ul className="list-disc list-inside">
            <li>Show suitable matches</li>
            <li>Improve our services</li>
            <li>Contact you for support or updates</li>
            <li>Ensure safety and prevent fraud</li>
          </ul>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-2 text-[#730000]">
            3. Who Sees Your Data
          </h2>
          <p className="mb-2">Your data is:</p>
          <ul className="list-disc list-inside">
            <li>Shared only with registered users</li>
            <li>Not sold or shared with third parties for marketing</li>
            <li>Shown only to users relevant to your preferences</li>
          </ul>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-2 text-[#730000]">
            4. How We Keep It Safe
          </h2>
          <p className="mb-2">We use:</p>
          <ul className="list-disc list-inside">
            <li>Secure servers</li>
            <li>Encrypted connections</li>
            <li>Strict access controls</li>
          </ul>
          <p className="mt-2">But no method is 100% secure. Please be cautious while sharing sensitive information.</p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-2 text-[#730000]">
            5. Cookies
          </h2>
          <p className="mb-2">We may use cookies to:</p>
          <ul className="list-disc list-inside">
            <li>Improve site performance</li>
            <li>Track visitor behavior</li>
          </ul>
          <p className="mt-2">You can disable cookies in your browser anytime.</p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-2 text-[#730000]">
            6. Your Rights
          </h2>
          <p className="mb-2">You can:</p>
          <ul className="list-disc list-inside">
            <li>Edit your profile</li>
            <li>Request to delete your account</li>
            <li>Ask us to stop contacting you</li>
          </ul>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-2 text-[#730000]">
            7. Contact Us
          </h2>
          <p className="mb-2">
            Have questions?
          </p>
          <p className="mb-2">
            Email us at: <span className="font-bold">info@selectproposal.com</span>
          </p>
          <p className="mb-2">
            We’ll respond as soon as possible.
          </p>
        </div>

      </div>
    </div>
  );
};

export default TermAndConditions;
